
import React from 'react';


import {connect} from 'react-redux';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './sobrenosotrosstp94.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Psobrenosotrosstp94 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {




  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6751f7aa1de4874021c1530c" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <span>Inicio</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <span>Sobre Nosotros</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/servicios"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <span>Servicios</span>
    </div>
    
      </a>
      
      </div>
      
      <div
        id="i0y3mu"
        className=""
        data-aos="zoom-out-down"
        data-aos-duration="1500"
      >
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afizry.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/contrata"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <span>Contrata</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="im06bc"
        href="/contacto"
        type="button"
      >
        
    <div id="ifflju" className="">
    <span>Contacto</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/proveedores"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <span>Proveedores</span>
    </div>
    
      </a>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <span>Inicio</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <span>Sobre Nosotros</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/servicios"
        type=""
      >
        <span>Servicios</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contrata"
        type=""
      >
        <span>Contrata</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <span>Contacto</span>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/proveedores"
        type=""
      >
        <span>Proveedores</span>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i17hyw" className="">
      
      </div>
      
      <div
        id="iawv86"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="iz8mng" className="">
      
      <div id="io8y2k" className="">
      
      <div id="iuhg3b" className="">
      
    <div id="i4z4a8" className="">
    
    </div>
    
      <p className="" id="i4kgfg">
        <span>¿Qué es Ineven?</span>
      </p>
      
      </div>
      
      <p className="" id="ixk7il">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="ivt99j">
        <span>SOBRE NOSOTROS</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ima16j" className="">
      
      </div>
      
      <div id="ipenyj" className="">
      
      <div id="iaj45f" className="">
      
      <p className="" id="i15ycp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ivkvaz">
        <span>UN NOMBRE QUE INSPIRA</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i39vrh" className="">
      
      <p className="" id="iovh6h">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="idq6i6">
        <span>"Ineven" es una fusión de las palabras "Ingeniería" y "Eventos". Elegimos este nombre deliberadamente; ya que refleja nuestra filosofía de abordar cada evento con la precisión y el enfoque meticuloso de un ingeniero</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="io4l7f" className="">
      
      </div>
      
      <div id="ijyhqk" className="">
      
      <p className="" id="izd8cf">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="iwq0hk">
        <span>SOMOS MÁS QUE PLANIFICADORES DE EVENTOS</span>
      </span>
      
      </p>
      
      <div id="iy89uj" className="">
      
      </div>
      
      <div id="in2sr3" className="">
      
      <p className="" id="idnco8">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="itqqhw">
        <span>SOMOS MÁS QUE PLANIFICADORES DE EVENTOS</span>
      </span>
      
      </p>
      
      <p className="" id="iu3lri">
        <span>Somos narradores de historias.</span>
      <br className="" id="" />
      <span>Diseñadores de momentos</span>
      </p>
      
      </div>
      
      </div>
      
      <div id="iy4cuf" className="">
      
      </div>
      
      <div id="iwytdm" className="">
      
      <p className="" id="i5znhb">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itvkie">
        <span>Nuestro Compromiso Contigo</span>
      </span>
      
      </p>
      
      <div id="ifhe55" className="">
      
    <div id="i486ur" className="">
    
    </div>
    
      <p className="" id="ix6aid">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="io4253">
        <span>Tú confianza en nosotros es un honor que valoramos profundamente, y nos esforzamos por ganárnosla en cada etapa del proceso</span>
      </span>
      
      </p>
      
    <div id="i2ydig" className="">
    
    </div>
    
      </div>
      
      </div>
      
      <div id="ir6wyt" className="">
      
      </div>
      
      <div id="i1w9qf" className="">
      
      <p className="" id="i3o9x7">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ikntnv">
        <span>Equipo y Enfoque</span>
      </span>
      
      </p>
      
      <div id="ivor58" className="">
      
      <div id="i85uft" className="">
      
      <p className="" id="ijkn3q">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i440ej">
        <span>Mentes creativas</span>
      </span>
      
      </p>
      
    <div id="iwfcfd" className="">
    
    </div>
    
      </div>
      
      <div id="ir5xad" className="">
      
    <div id="il28tk" className="">
    
    </div>
    
      <img
        className=""
        id="i7wcr5"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bq2qre.png"
        alt="undefined"
      />
      
    <div id="ie8mtv" className="">
    
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="ir2czw" className="">
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afizry.png"
        alt="undefined"
      />
      
      <p className="" id="iyo7r6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="il8o0q">
        <span>Ingenieria de eventos.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div id="ipwalf" className="">
      
      <img
        className=""
        id="icnrzk"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4vijr82.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="iw8qql"
          href="https://www.tiktok.com/@ineven.vip?_t=8sKdB0x1PBG&_r=1"
        >
          
    <div id="ixrp8j" className="">
    <span>ineven.vip</span>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      <div id="ioiagi" className="">
      
      <img
        className=""
        id="izko5z"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bmczdi.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ihiwwu"
          href="https://www.facebook.com/ineven.vip"
        >
          
    <div id="i9av2f" className="">
    <span>ineven.vip</span>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      <div id="igk236" className="">
      
      <img
        className=""
        id="i9z0pd"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bmd43v.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="iu23om"
          href="https://www.instagram.com/ineven.vip?igsh=b25xZHA5MDVqaDVp"
        >
          
    <div id="ihe3m8" className="">
    <span>@ineven.vip</span>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      <div id="io5w49" className="">
      
      <img
        className=""
        id="i6uigw"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4viijg2.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="iz65ch"
          href="https://www.linkedin.com/company/ineven/"
        >
          
    <div id="i8e1fd" className="">
    <span>ineven.vip</span>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="i1rlot" className="">
      
      <p className="" id="iw7za7">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ic71jf">
        
      <a
        target=""
        className=""
        id="ip9vzm"
        href="/sobrenosotros"
        type=""
      >
        <span>Sobre nosotros</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="i3340b">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ih08ak">
        
      <a
        target=""
        className=""
        id="iqjrmd"
        href="/servicios"
        type=""
      >
        <span>Nuestros servicios</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="ijqtal">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itkfgw">
        
      <a
        target=""
        className=""
        id="i8f62k"
        href="/contrata"
        type=""
      >
        <span>Hazlo tú mismo</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="ik2e3t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it8v73">
        
      <a
        target=""
        className=""
        id="iomv8p"
        href="/proveedores"
        type=""
      >
        <span>Testimonio</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="i38bqt">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ib7tnq">
        
      <a
        target=""
        className=""
        id="iet9fb"
        href="/contacto"
        type=""
      >
        <span>Contáctanos</span>
      </a>
      
      </span>
      
      </p>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <p className="" id="ifh7p5">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ita68z">
        <span>+504 9574-8270</span>
      </span>
      
      </p>
      
      <p className="" id="i78qcc">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="imjhna">
        <span>Col. Colonia, 7 calle, 8 avenida S.O</span>
      </span>
      
      </p>
      
      <p className="" id="il1rnw">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6f3bu">
        <span>ingenierodeevento@gmail.com</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <p className="" id="izq2dp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ieap6m">
        <span>Todos los derechos reservados - Ineven - 2022 </span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Psobrenosotrosstp94);
  